import { render, staticRenderFns } from "./PresupuestoReporteIngresos.vue?vue&type=template&id=1059eafc"
import script from "./PresupuestoReporteIngresos.vue?vue&type=script&lang=js"
export * from "./PresupuestoReporteIngresos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports